import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
// Reducers
import processSteps from "./processSteps";
import { loans } from "./loans";
import { modal } from "./modal";
import { notification } from "./notification";
import { token } from "./token";
import { payment } from "./payment";
import { appStatus } from "./appStatus";
import { achInstitution } from "./achInstitution";
import { payoffCheck } from "./payoffCheck";
import { authPayment } from "./authPayment";
import { cardControls } from "./cardControls";
import { mfa } from "./mfa";

const appReducers = combineReducers({
  processSteps,
  loans,
  modal,
  notification,
  token,
  payment,
  appStatus,
  achInstitution,
  payoffCheck,
  authPayment,
  mfa,
  cardControls,
  form: formReducer,
});

// If the action is RESTART_APP, reset the app back to its initial state
const rootReducer = (state, action) => {
  if (action.type === "RESTART_APP") {
    state = undefined;
  }
  return appReducers(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js